/** Events a client predicts for its own mech and therefore ignores when the server repeats them. */
const OWN_ACTIONS = new Set([
    'shot',
    'projectileSpawn',
    'beam',
    'melee',
    'reload',
    'overheat',
    'vent',
    'ability',
    'deployableSpawn',
    'padLaunch',
]);
/** The slot an event is about (its actor), or null for events without one. */
export function eventSlot(e) {
    switch (e.t) {
        case 'shot':
        case 'projectileSpawn':
        case 'beam':
        case 'explosion':
        case 'melee':
        case 'ability':
        case 'effectStart':
        case 'effectEnd':
        case 'overheat':
        case 'vent':
        case 'shieldBroken':
        case 'reload':
        case 'deployableSpawn':
        case 'parry':
        case 'ultCharged':
            return e.slot;
        case 'hit':
        case 'blocked':
            return e.source;
        case 'kill':
            return e.killer;
        default:
            return null;
    }
}
/** Keeps the events a client shows from the given origin (see the module comment). */
export function filterEvents(events, mySlot, origin) {
    const out = [];
    for (const e of events) {
        const own = OWN_ACTIONS.has(e.t) && eventSlot(e) === mySlot;
        if (origin === 'predicted' ? own : !own)
            out.push(e);
    }
    return out;
}
/**
 * True when an authoritative event explains a correction of `slot`'s own mech: a hit or effect
 * on it, its death, or a change of round phase (the server freezes both mechs at a round end
 * before the client can know).
 */
export function explainsCorrection(e, slot) {
    switch (e.t) {
        case 'hit':
            return e.target === slot;
        case 'effectStart':
            return e.slot === slot;
        case 'kill':
            return e.victim === slot;
        case 'roundStart':
        case 'live':
        case 'roundEnd':
        case 'suddenDeath':
        case 'matchEnd':
            return true;
        default:
            return false;
    }
}
//# sourceMappingURL=events.js.map